import React from "react";


const WarningAlert = ({alert}) => {
    return(
        <div
            className=" self-start mt-4 p-3 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 flex items-center rounded-lg w-fit">
            <svg className="w-12 h-12 md:w-8 md:h-8 mb-auto text-yellow-700 mr-2" fill="none" stroke="currentColor" strokeWidth="2"
                 viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="M12 9v2m0 4h.01M4.93 19h14.14a2 2 0 001.732-3L13.732 4a2 2 0 00-3.464 0L3.198 16a2 2 0 001.732 3z"></path>
            </svg>
            <span>{alert}</span>
        </div>
    )
}

export default WarningAlert;